export default "__VITE_ASSET__BQInQkE3__"